import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// Services
import { ConfigService, LoggerService, SystemApiService } from '@cv-invision/core';
import { ViewsService } from '../../../../services/views.service';
import { SchemasService } from '../../../../services/schemas.service';
import { MapViewConfigModel } from '@cv-invision/cv.component-library.ux'
// Other
import { Subscription } from 'rxjs';
import { toNumber } from 'lodash';

@Component({
	selector: 'cv-review-fields-display',
	templateUrl: './display-fields.component.html',
	styleUrls: ['./display-fields.component.scss']
})
export class DisplayFieldsComponent implements OnInit, OnDestroy {
	@Input() fieldOptions: any;
	// @Input() control: FormControl;
	@Input() field: any;
	@Input() value: any;
	@Input() historical: Array<any>;
	@Input() show: any;
	@Input() active = false;
	@Output() openHistorical: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('changesEl', { read: ElementRef, static: false }) changesEl: ElementRef;

	public mapConfiguration = new MapViewConfigModel();

	targets = [];
	highlight = '';

	gps = {
		lat: 0,
		long: 0
	};

	iconExist = false;
	icon = '';
	icons = {
		'stable': 'fa fa-arrows-alt-h',
		'decreasing': 'fa fa-arrow-circle-down',
		'declining': 'fa fa-arrow-circle-down',
		'slow': 'fa fa-arrow-circle-down',
		'increasing': 'fa fa-arrow-circle-up',
		'rapid': 'fa fa-arrow-circle-up',
		'yes': 'fa fa-check',
		'no': 'fa fa-times',
		'avg': 'fa fa-star-half-alt',
		'gd': 'fa fa-star',
		'good': 'fa fa-star',
		'average': 'fa fa-star-half-alt',
		'poor': 'far fa-star'
	};

	serviceSubscription: Subscription;

	get module(): any {
		return true;
	}
	get document(): any {
		return this.viewsService.document;
	}

	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService,
		private configService: ConfigService,
		private viewsService: ViewsService,
		private schemaService: SchemasService,
		private console: LoggerService
	) {
	}

	async ngOnInit(): Promise<void> {
		this.mapConfiguration.setMapKey(this.configService.publicKey.googleMaps);
		if (typeof this.value === 'string' && this.value.toLocaleLowerCase() in this.icons) {
			this.icon = this.value.toLocaleLowerCase();
			this.iconExist = true;
		}

		if (typeof this.value === 'string' && this.value !== '') {
			this.value = this.value.replace(/([a-z])([A-Z])/g, '$1 $2');
			this.value = this.value.replace(/([a-z])([1-9])/g, '$1 $2');
			this.value = this.value.replace(/([1-9])([A-Z])/g, '$1 $2');
		}

		if ('displayType' in this.fieldOptions && this.fieldOptions.displayType === 'map') {
			if ('address' in this.fieldOptions) {
				const addressArray = [
					this.schemaService.value(this.document, `$.${this.fieldOptions.address[0]}`).Value,
					this.schemaService.value(this.document, `$.${this.fieldOptions.address[1]}`).Value,
					this.schemaService.value(this.document, `$.${this.fieldOptions.address[2]}`).Value
				];

				this.serviceSubscription = this.httpClient.get(this.systemApiService.api.intelligenceService + `geo-services/geocode?formattedAddress=${addressArray.join(',')}`)
					.subscribe((response: any) => {
					if (response.valid) {
						this.gps.lat = response.latitude;
						this.gps.long = response.longitude;
						this.mapConfiguration.setMainLocation({ latitude: this.gps.lat, longitude: this.gps.long });
					}
				});
			} else {
				this.gps.lat = parseFloat(this.schemaService.value(this.document, `$.${this.fieldOptions.gps}`).latitude.Value);
				this.gps.long = parseFloat(this.schemaService.value(this.document, `$.${this.fieldOptions.gps}`).longitude.Value);
				this.mapConfiguration.setMainLocation({ latitude: this.gps.lat, longitude: this.gps.long });
			}
			this.mapConfiguration.setOptions({ mapTypeId: 'roadmap' })
		}
	}

	ngOnDestroy(): void {
		if (this.serviceSubscription) {
			this.serviceSubscription.unsubscribe();
		}
	}

	/**
	 * open historical component
	 * @param item
	 * @param historical
	 */
	showHistorical(): void {
		this.openHistorical.emit(this.changesEl);
	}

	/**
	 * parseNumeric
	 *
	 * @param value
	 */
	parseNumeric(value: any): any {
		const newVal = toNumber(value.replace(/,/g, ''));
		return newVal;
	}

	/**
	 * isNumber
	 *
	 * @param val
	 */
	isNumber(value: any): boolean {
		const test = parseFloat(value);
		return typeof test === 'number' && !isNaN(test);
	}
}
